import { defineMessages, useIntl } from "react-intl";

import { Chip, type ChipColor } from "@/components/Chip/Chip";
import type { FindUserReservationsExternalFlightReservation } from "@/types/codegen";

type Props = {
  status: FindUserReservationsExternalFlightReservation["status"];
};

const statusToColorMapping: {
  [key in FindUserReservationsExternalFlightReservation["status"]]: ChipColor;
} = {
  IN_PROGRESS: "warning",
  TICKET_ISSUED: "success",
  OK: "success",
  BOOKED: "success",
  REFUNDED: "error",
};

const statusLabels = defineMessages<string>({
  IN_PROGRESS: {
    defaultMessage: "In Progress",
    description: "Order status label: ticket issuance in progress",
  },
  TICKET_ISSUED: {
    defaultMessage: "Ticket issued",
    description: "Order status label: ticket has been successfully issued",
  },
  OK: {
    defaultMessage: "Booked",
    description: "Order status label: booking confirmed",
  },
  BOOKED: {
    defaultMessage: "Booked",
    description: "Order status label: booking confirmed",
  },
  REFUNDED: {
    defaultMessage: "Refunded",
    description: "Order status label: booking has been refunded",
  },
});

export const OrderLabel = ({ status }: Props) => {
  const intl = useIntl();

  return (
    <Chip
      color={statusToColorMapping[status]}
      label={intl.formatMessage(statusLabels[status])}
    />
  );
};
